import { useQuery, useQueryClient } from '@tanstack/react-query';
import { DEMO_ACCOUNT_DATASET_NAME, type AccountInfo } from '@sl/core';
import { identityRequest, type Identity } from '../../routes/acquisition/identity';

export const DEMO_ACCOUNT_LABEL = `Demo: ${DEMO_ACCOUNT_DATASET_NAME}`;
export const isDemoAccount = (account: Pick<AccountInfo, 'mode'>) =>
  account.mode === 'demo' || account.mode === 'demo_view_only_preview';
export const accountDisplayName = (account: AccountInfo) =>
  isDemoAccount(account) ? `Demo: ${account.name.replace(/^Demo: /, '')}` : account.name;

const key = ['identity', 'demo-account'] as const;
type DemoIdentity = Identity | { authenticated: false };

/** Saved with the verified person, independent of the selected data transport and browser. */
export function useDemoAccount() {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: key,
    queryFn: () => identityRequest<DemoIdentity>('session?optional=true'),
    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
  const identity = query.data && 'email' in query.data ? query.data : null;
  const setHidden = async (hidden: boolean) => {
    const updated = await identityRequest<Identity>('demo-account', { hidden });
    client.setQueryData<DemoIdentity>(key, updated);
  };
  return { ...query, identity, hidden: identity?.demoAccountHidden === true, setHidden };
}
